import React, { Component } from "react";
import { connect } from "react-redux";
import CommentsList from "./components/CommentsList";
import CommentInputCreate from "./components/CommentInput/CommentInputCreate";
import InteractionsGroup from "./components/InteractionsGroup";
import "./index.css";

class Interactions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileCommentInputRef: null,
    };
  }

  componentDidMount() {
    this.setState({
      mobileCommentInputRef: this.mobileCommentInputRef,
    });
  }

  render() {
    const comments = this.props.post.comments;
    return (
      <section className="interactions-wrapper">
        <InteractionsGroup
          post={this.props.post}
          desktopCommentInputRef={this.props.desktopCommentInputRef}
          mobileCommentInputRef={this.state.mobileCommentInputRef}
        />
        <div className="comments-area-wrapper">
          <CommentsList comments={comments} postId={this.props.post._id} />
          <CommentInputCreate className="-mobile" getInputRef={input => (this.mobileCommentInputRef = input)} />
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    post: state.posts.current,
  };
}

export default connect(mapStateToProps)(Interactions);



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/index.js